import { render, staticRenderFns } from "./OffsiteLocation.vue?vue&type=template&id=08f0fc94"
import script from "./OffsiteLocation.vue?vue&type=script&lang=js"
export * from "./OffsiteLocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports